/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsError = {
    /**
     * Handle errors during product fetch
     *
     * @param {Error} error - The error object.
     */
    handleProductFetchError(error) {
        console.error('Error fetching or mapping products:', error)

        this.productFetchErrorMessage = this.errorMessages.productFetchError

        if (!this.productsInitialLoaded) {
            this.removeSkeleton()
        }

        // Error message to user
        typeof window.dispatchMessages !== 'undefined' && window.dispatchMessages(
            [{
                type: 'error',
                text: this.errorMessages.productFetchError
            }],
            5000
        )
    },
    /**
     * Retry the last product fetch with the same parameters.
     *
     * @returns {Promise<void>}
     */
    async retryProductFetch() {
        if (!this.lastProductRequest || this.productsLoading) {
            return
        }

        this.productFetchErrorMessage = ''
        await this.getProducts(
            this.lastProductRequest.type,
            this.lastProductRequest.pagination
        )
    }
}

export default liveSearchProductsError
